import { FilterChip } from "@volca/ui/components/ui/filter-chip";

/**
 * A chip per column with blank cells, in the file's column order ("2 blank in
 * Labor Cost"). Pressed, it narrows the table to the rows that leave that
 * column blank; pressed again, or cleared, it puts them all back. A missing
 * figure in the report leads here: these are the rows it came from.
 */
export const BlankChips = ({
  blanks,
  columns,
  active,
  onChange,
}: {
  blanks: Record<string, number>;
  columns: string[];
  active: string | null;
  onChange: (column: string | null) => void;
}) => {
  const counted = columns.filter((column) => blanks[column] > 0);
  if (!counted.length) return null;
  return (
    <ul aria-label="Blank cells" className="contents">
      {counted.map((column) => (
        <li key={column}>
          <FilterChip
            size="sm"
            label={`${blanks[column].toLocaleString()} blank in`}
            value={column}
            active={active === column}
            aria-pressed={active === column}
            aria-label={
              active === column
                ? "Show all rows"
                : `Show the ${blanks[column]} rows with no ${column}`
            }
            onClick={() => onChange(active === column ? null : column)}
            onClear={active === column ? () => onChange(null) : undefined}
          />
        </li>
      ))}
    </ul>
  );
};
